<template>
  <div class="top-bar">

    <h1 @click="$router.push('/')">
      KAI FUGLEM
      <span class="photography">PHOTOGRAPHY</span>
    </h1>

    <font-awesome-icon
      :icon="['far', 'camera-alt']"
      class="camera"
      @click="$router.push('/')"
    />

    <div
      class="menu-button"
      @click="isMenuOpen = !isMenuOpen"
    >
      <font-awesome-icon :icon="['far', 'bars']" />
    </div>

    <transition name="expand">
      <div
        v-if="isMenuOpen"
        class="menu"
        @click="closeMenu"
        v-on-clickaway="closeMenu"
      >
        <ul>
          <li><router-link to="/sports">Sports</router-link></li>
          <li><router-link to="/nature">Nature</router-link></li>
          <li><router-link to="/automotive">Automotive</router-link></li>
          <li><router-link to="/contact">Contact</router-link></li>
        </ul>
      </div>
    </transition>

  </div>
</template>

<script>
import { mixin as clickaway } from 'vue-clickaway';

export default {
  name: 'TopBar',

  mixins: [ clickaway ],

  data() {
    return {
      isMenuOpen: false,
    };
  },

  methods: {
    closeMenu() {
      this.isMenuOpen = false;
    },
  },
}
</script>

<style lang="scss" scoped>
$padding: 16px;
$border-width: 2px;
$topBarHeight: 60px + $padding*2 + $border-width;

.top-bar {
  position: fixed;
  top: 0;
  padding: 0;
  width: 100%;
  border-bottom: $border-width solid white;
  display: flex;
  align-items: center;
  background: rgba(25, 25, 25, 0.8);
  z-index: 1;

  h1 {
    font-family: effra, Helvetica, Arial, sans-serif;
    margin: 0 $padding 0 $padding*2;
    padding: 0;
    font-size: 14px;
    letter-spacing: 11px;
    color: #ffffff;
    height: 92px;
    line-height: 92px;
    font-weight: 700;
    cursor: pointer;
    transition: all 0.3s ease;

    @media (max-height: 500px) {
      height: 60px;
      line-height: 60px;
    }
  }

  span.photography {
    @media (max-width: 600px) {
      display: none;
    }
  }

  svg.camera {
    @media (min-width: 601px) {
      display: none;
    }
  }

  .menu-button {
    margin-left: auto;
    margin-right: $padding;
    padding: $padding;
    cursor: pointer;
  }
}

.menu {
  position: fixed;
  top: $topBarHeight;
  right: 0;
  background: rgba(0, 0, 0, 0.9);
  padding: 0;
  min-width: 300px;
  max-height: calc(100vh - #{$topBarHeight});
  overflow-y: auto;
  overflow-x: hidden;

  @media (max-width: 800px) {
    width: 100%;
    height: 100%;
  }

  @media (max-height: 500px) {
    top: $topBarHeight - $padding*2;
    max-height: calc(100vh - #{$topBarHeight - $padding*2});
  }

  ul {
    margin: 0;
    padding: 0;
    list-style: none;

    a {
      display: block;
      width: 100%;
      padding: $padding*2 $padding*3;
      text-decoration: none;
      text-transform: uppercase;
      color: #959595;
      letter-spacing: 2.5px;
      font-size: 12px;
      transition: all 0.3s ease;

      &:hover {
        color: white;
      }
    }

    li:first-of-type a {
      padding-top: $padding*3;
    }
    li:last-of-type a {
      padding-bottom: $padding*3;
    }
  }
}

.expand-enter-active,
.expand-leave-active {
  transition: all 0.15s ease-in-out 0ms;
  max-height: 700px;
  opacity: 1;
  overflow: hidden;
}

.expand-enter,
.expand-leave-to {
  max-height: 0;
  opacity: 0;
}
</style>
